<template>
  <div class="event-history-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">License Event History</h5>
      <a-select
        v-model:value="eventTypeFilter"
        style="width: 180px"
        placeholder="Filter by event type"
        allow-clear
        @change="handleFilterChange"
      >
        <a-select-option value="license_assigned">License Assigned</a-select-option>
        <a-select-option value="license_revoked">License Revoked</a-select-option>
        <a-select-option value="device_added">Device Added</a-select-option>
        <a-select-option value="device_removed">Device Removed</a-select-option>
        <a-select-option value="pool_updated">Pool Updated</a-select-option>
      </a-select>
    </div>

    <a-table
      :columns="columns"
      :data-source="events"
      :loading="loading"
      :pagination="pagination"
      bordered
      :scroll="{ x: 800 }"
      row-key="id"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'event_type'">
          <a-tag :color="getEventTypeColor(record.event_type)">
            {{ formatEventType(record.event_type) }}
          </a-tag>
        </template>
        <template v-if="column.key === 'device_name'">
          {{ record.device_name || '-' }}
        </template>
        <template v-if="column.key === 'actor_email'">
          {{ record.actor_email || 'System' }}
        </template>
        <template v-if="column.key === 'created_at'">
          {{ formatDate(record.created_at) }}
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: 'EventHistoryPanel',
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['filter-change'],
  data() {
    return {
      eventTypeFilter: null,
      pagination: {
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total) => `Total ${total} events`,
      },
      columns: [
        {
          title: 'Event Type',
          dataIndex: 'event_type',
          key: 'event_type',
          width: '20%',
        },
        {
          title: 'Device',
          dataIndex: 'device_name',
          key: 'device_name',
          width: '25%',
        },
        {
          title: 'Performed By',
          dataIndex: 'actor_email',
          key: 'actor_email',
          width: '25%',
        },
        {
          title: 'Date',
          dataIndex: 'created_at',
          key: 'created_at',
          width: '30%',
        },
      ],
    };
  },
  methods: {
    handleFilterChange(value) {
      this.$emit('filter-change', { event_type: value });
    },
    formatEventType(type) {
      const types = {
        license_assigned: 'License Assigned',
        license_revoked: 'License Revoked',
        device_added: 'Device Added',
        device_removed: 'Device Removed',
        pool_created: 'Pool Created',
        pool_updated: 'Pool Updated',
      };
      return types[type] || type;
    },
    getEventTypeColor(type) {
      const colors = {
        license_assigned: 'green',
        license_revoked: 'red',
        device_added: 'blue',
        device_removed: 'orange',
        pool_created: 'purple',
        pool_updated: 'cyan',
      };
      return colors[type] || 'default';
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
.event-history-container {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
